import { Checkbox, Col, Dropdown, Menu, Row } from "antd";
import Input from "components/common/Input";
import MoreOptionHorizontal from "components/icons/MoreOptionHorizontal";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import s from "../styles";
import InputNumber from "../../../../components/common/InputNumber";

function Modifier({ index, setFieldValue, values, errors, handleRemoveItem }) {
  const { t } = useTranslation();
  function applyItemStyle(selected) {
    return {
      height: "45px",
      color: selected && Colors.text_on_secondary,
      marginBottom: "10px",
      borderRadius: "2px",
      hover: {
        backgroundColor: "red",
        color: Colors.text_on_secondary,
      },
    };
  }

  const menu = (
    <Menu
      style={{
        overflow: "auto",
        padding: "8px",
        paddingBottom: 0,
        minWidth: "147px",
        textAlign: "center",
      }}
    >
      <Menu.Item
        disabled={values.modifiers.length === 1}
        key="delete"
        onClick={() => {
          handleRemoveItem(index);
        }}
        style={{ ...applyItemStyle(), color: Colors.notification_failed }}
      >
        {t("containers.InventoryModifiers.AddModifier.delete")}
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Row gutter={93}>
        <Col span={12} style={{ marginBottom: "32px" }}>
          <Row gutter={10}>
            <Col span={17}>
              <s.SubTitle style={{ marginBottom: "8px" }}>
                {t("containers.InventoryModifiers.AddModifier.component")}
                {index + 1}
              </s.SubTitle>
            </Col>
            <Col span={7}>
              <s.SubTitle style={{ marginBottom: "8px" }}>
                {t("containers.InventoryModifiers.AddModifier.price")}
              </s.SubTitle>
            </Col>
            <Col span={17}>
              <Input
                placeholder={t(
                  "containers.InventoryModifiers.AddModifier.complement"
                )}
                name="name"
                value={values.modifiers[index].name}
                onChange={(e) =>
                  setFieldValue(`modifiers.${index}.name`, e.target.value)
                }
              />
              {errors?.modifiers?.length > 0
                ? errors.modifiers[index]?.name && (
                    <s.messageAlert style={{ marginBottom: "-32px" }}>
                      {t(
                        "containers.InventoryModifiers.AddModifier.componentNameRequired"
                      )}
                    </s.messageAlert>
                  )
                : null}
            </Col>
            <Col span={7}>
              <InputNumber
                type="number"
                placeholder="0.00€"
                name="price"
                value={values.modifiers[index].price}
                onChange={(e) =>
                  setFieldValue(`modifiers.${index}.price`, e.target.value)
                }
              />
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Row gutter={10}>
            <Col span={24}>
              <s.SubTitle style={{ marginBottom: "8px" }}>
                {t("containers.InventoryModifiers.AddModifier.selection")}
              </s.SubTitle>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col
              xs={24}
              md={7}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Checkbox
                name="toAdd"
                onChange={(e) =>
                  setFieldValue(`modifiers.${index}.toAdd`, e.target.checked)
                }
                checked={values.modifiers[index].toAdd}
              >
                {t("containers.InventoryModifiers.AddModifier.isAdded")}
              </Checkbox>
            </Col>
            <Col
              xs={24}
              md={7}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Checkbox
                name="toRemove"
                onChange={(e) =>
                  setFieldValue(`modifiers.${index}.toRemove`, e.target.checked)
                }
                checked={values.modifiers[index].toRemove}
              >
                {t("containers.InventoryModifiers.AddModifier.isRemoved")}
              </Checkbox>
            </Col>
            <Col
              xs={24}
              md={7}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Checkbox
                name="isQuantifiable"
                onChange={(e) =>
                  setFieldValue(
                    `modifiers.${index}.isQuantifiable`,
                    e.target.checked
                  )
                }
                checked={values.modifiers[index].isQuantifiable}
              >
                {t("containers.InventoryModifiers.AddModifier.isGroup")}
              </Checkbox>
            </Col>
            <Col xs={24} md={3}>
              <s.TableCell>
                <Dropdown
                  placement="bottomRight"
                  overlay={menu}
                  trigger={["click"]}
                  arrow
                >
                  <div style={{ cursor: "pointer", height: "15px" }}>
                    <MoreOptionHorizontal />
                  </div>
                </Dropdown>
              </s.TableCell>
            </Col>
          </Row>
        </Col>
      </Row>
      <s.Dividir />
    </>
  );
}

export default Modifier;
